import styled from 'styled-components';

export default styled.circle`
  fill: ${props => props.color};
  r: 4px;
  stroke: white;
  stroke-width: 2px;
`;
